import { Component } from 'vue-property-decorator';
import EditorBase from './EditorBase';
import UserApi from '@/apis/user-api';
import { Loading } from 'streamlabs-beaker';

@Component({
  components: {
    SLoading: Loading,
  }
})
export default class YoutubeStreamContainer extends EditorBase {
  mounted() {
    setTimeout(() => {
      this.retriveYoutubeLiveVideoId();
    }, 3000);
  }

  get origin(): string {
    return window.location.hostname;
  }

  get videoId(): string {
    return this.userModule.youtubeLiveVideoId;
  }

  async retriveYoutubeLiveVideoId(retries = 0) {
    if (this.videoId) {
      return;
    }

    const response = await UserApi.getYoutubeLiveChatId();
    this.userModule.setYoutubeLiveVideoId(response.video_id);

    if (!response.video_id && this.isLive && retries < 3) {
      setTimeout(() => {
        this.retriveYoutubeLiveVideoId(++retries);
      }, 3000)
    }
  }
}
